export function fromDriveFolder(item) {
    return {
        id: item.id,
        title: item.title,
        type: item.type,
        collapsed: true,
        children: item.children?.map(fromDriveFolder),
    };
}
